import {useMemo} from 'react';

import {ConversationHighlightModel, HighlightModel} from '../../../../models/api/conversationHighlightModel';

const maxIndicatorsInExpandedMode = 6;
const maxIndicatorsInCompactMode = 3;

interface ComputeMaximumNumberOfCellIndicatorsOptions {
  highlight: ConversationHighlightModel | HighlightModel | undefined;
  numberOfTags: number;
  isStarred: boolean;
  isOriginalConversation: boolean;
  isCompact: boolean;
}

function computeMaximumNumberOfCellIndicators({
  highlight,
  numberOfTags,
  isStarred,
  isOriginalConversation,
  isCompact,
}: ComputeMaximumNumberOfCellIndicatorsOptions) {
  const baseMax = isCompact ? maxIndicatorsInCompactMode : maxIndicatorsInExpandedMode;
  // The max number of indicators to render including star/linked conversation indicators
  let maxIndicators = highlight ? baseMax - 1 : baseMax;
  if (isStarred) {
    maxIndicators -= 1;
  }
  if (isOriginalConversation) {
    maxIndicators -= 1;
  }

  // If we have more than 3 tags, we need to count the "+", starred & linked convo indicators as columns.
  let indicatorsWrapperColumns = numberOfTags > maxIndicators ? maxIndicators + 1 : numberOfTags;
  if (isStarred) {
    indicatorsWrapperColumns += 1;
  }
  if (isOriginalConversation) {
    indicatorsWrapperColumns += 1;
  }

  return {
    maxIndicators,
    indicatorsWrapperColumns,
  };
}

export function useMaximumNumberOfCellIndicators(options: ComputeMaximumNumberOfCellIndicatorsOptions) {
  return useMemo(() => computeMaximumNumberOfCellIndicators(options), [options]);
}
